import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-http',
    templateUrl: './http.component.html',
    styleUrls: ['./http.component.scss'],
    standalone: false
})
export class HttpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
